module.exports = __webpack_public_path__ + "static/media/5@2x.b57575cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_148/img/5@2x.png
// module id = 1426
// module chunks = 0